import { FieldValues, UseFormSetValue } from 'react-hook-form';

export const clearStepThreeMapping = <T extends FieldValues>(setValue: UseFormSetValue<T>) => {
  const set = setValue as UseFormSetValue<FieldValues>;
  set('stepThree.fileParsed', false);
  set('stepThree.fieldMapping', {});
  set('stepThree.fieldMappingTypes', {});
  set('stepThree.detectedVariables', []);
  set('stepThree.tabs', []);
  set('stepThree.mergeFieldIssues', []);
};
